/**
 * Reads the Stripe platform publishable key from Vite's build-time env.
 *
 * Vite statically replaces `import.meta.env.VITE_*` at transform time —
 * vitest's `vi.stubEnv` does NOT affect those replacements, so this
 * function exists primarily as a seam for tests to `vi.mock()`.
 *
 * In production, set VITE_STRIPE_PUBLISHABLE_KEY at build time (see
 * apps/web/.env.example). When the key is missing, callers should
 * skip rendering payment UI rather than send Stripe.js a blank key.
 */
export function getStripePublishableKey(): string {
  const envBag = (import.meta as unknown as { env?: Record<string, string | undefined> }).env;
  return envBag?.VITE_STRIPE_PUBLISHABLE_KEY ?? '';
}
